import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import clsx from 'clsx';
import MaskedTextInput from 'react-text-mask';
import { DebouncedInput, ErrorMessages, Select, withOverlayTrigger } from 'reaxl';

/**
 *  Describe the component
 *
 */
function PureFilterLocationForm(_ref) {
  let {
    className,
    filter = {},
    filters = {},
    errors = {},
    onOptionChange = () => {},
    onOptionsClear,
    values = {},
    resultCount,
    searchRadiusOptions,
    searchRadiusValue,
    zipOptions,
    zipValue,
    ...rest
  } = _ref;
  // remove unused props
  delete rest.component;
  delete rest.popoverPosition;
  delete rest.popoverTriggerEvent;
  const zipinputRef = useRef(null);
  const handleZipChange = event => {
    const zipOption = zipOptions || filters?.zip;
    onOptionChange(event, zipOption);
  };
  const debouncedInputProps = {
    type: 'tel',
    minLength: '1',
    maxLength: '5',
    pattern: '[0-9]{1,5}',
    component: MaskedTextInput,
    mask: [/\d/, /\d/, /\d/, /\d/, /\d/],
    autoComplete: 'postal-code',
    guide: false
  };
  const rootClassName = clsx('locationForm', className);
  const searchRadiusFilterOptions = searchRadiusOptions || filters?.searchRadius;
  const zipFilterOptions = zipOptions || filters?.zip;
  const zipFilterClassNames = clsx({
    'col-xs-5': searchRadiusFilterOptions,
    'col-xs-12': !searchRadiusFilterOptions
  });
  useEffect(() => {
    // When opening the filterLocationModal, if we want the zipinput to be highlighted or cursor to be inside the field, apply focus\
    if (zipFilterOptions?.focus) {
      zipinputRef.current.inputElement.focus();
    }
  }, [zipFilterOptions?.focus]);

  // TODO remove ...rest - should not be needed if root class name is available
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: rootClassName
  }, rest), /*#__PURE__*/_jsx("div", {
    className: "row"
  }, void 0, searchRadiusFilterOptions && /*#__PURE__*/_jsx("div", {
    className: "col-xs-7 text-nowrap"
  }, void 0, /*#__PURE__*/_jsx(Select, {
    label: searchRadiusFilterOptions?.label,
    onChange: event => onOptionChange(event, searchRadiusFilterOptions),
    options: searchRadiusFilterOptions?.options,
    name: searchRadiusFilterOptions?.name,
    value: searchRadiusValue || values?.searchRadius
  })), zipFilterOptions && /*#__PURE__*/_jsx("div", {
    className: zipFilterClassNames
  }, void 0, /*#__PURE__*/React.createElement(DebouncedInput, Object.assign({}, debouncedInputProps, {
    name: zipFilterOptions?.name,
    value: zipValue || values?.zip,
    label: zipFilterOptions?.label,
    className: "form-control",
    onChange: handleZipChange,
    key: zipFilterOptions?.name,
    id: "filterLocationZipInput",
    ref: zipinputRef
  })), errors[zipFilterOptions?.name] && /*#__PURE__*/_jsx(ErrorMessages, {
    errors: errors[zipFilterOptions?.name]
  }))), errors[filter.name] && /*#__PURE__*/_jsx(ErrorMessages, {
    errors: errors[filter.name]
  }));
}
export { PureFilterLocationForm };
export default withOverlayTrigger({
  defaultPosition: 'bottom',
  right: ['xs', 'landscape']
})(PureFilterLocationForm);